// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .events {
  background-color: #f6f3f3;
  padding-left: 20px;
}
.theme-light .events .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-light .events .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-light .events .images .eventsPic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-light .events .eventsContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-light .events .eventsContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-light .events .eventsContainer {
    padding: 20px;
  }
}
.theme-light .events .eventsContainer .cInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-light .events .eventsContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-light .events .eventsContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-light .events .eventsContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-light .events .eventsContainer .cInfo .center .eventsName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #f6f3f3;
  z-index: 99;
}
.theme-light .events .eventsContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-light .events .eventsContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #555;
}
.theme-light .events .eventsContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-light .events .eventsContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .events .eventsContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .events .eventsContainer .cInfo .eventsButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-light .events .eventsContainer .cInfo .eventsButtons {
    flex-wrap: wrap;
  }
}
.theme-light .events .eventsContainer .cInfo .eventsButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-light .events .eventsContainer .cInfo .eventsButtons a {
  color: #555;
}
.theme-dark .events {
  background-color: #333;
  padding-left: 20px;
}
.theme-dark .events .images {
  width: 100%;
  height: 300px;
  position: relative;
}
.theme-dark .events .images .cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.theme-dark .events .images .eventsPic {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 200px;
}
.theme-dark .events .eventsContainer {
  padding: 20px 70px;
}
@media (max-width: 480px) {
  .theme-dark .events .eventsContainer {
    padding: 10px;
  }
}
@media (max-width: 960px) {
  .theme-dark .events .eventsContainer {
    padding: 20px;
  }
}
.theme-dark .events .eventsContainer .cInfo {
  height: 180px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
@media (max-width: 480px) {
  .theme-dark .events .eventsContainer .cInfo {
    flex-direction: column;
    height: 30vh;
    padding: 20px;
    margin-top: 100px;
  }
}
.theme-dark .events .eventsContainer .cInfo .center {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.theme-dark .events .eventsContainer .cInfo .center span {
  font-size: 30px;
  font-weight: 500;
}
.theme-dark .events .eventsContainer .cInfo .center .eventsName {
  font-size: xx-large;
  font-weight: 500;
  border-radius: 20%;
  padding: 5px;
  background-color: #333;
  z-index: 99;
}
.theme-dark .events .eventsContainer .cInfo .center .info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.theme-dark .events .eventsContainer .cInfo .center .info .item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #d1d0c9;
}
.theme-dark .events .eventsContainer .cInfo .center .info .item span {
  font-size: 12px;
}
.theme-dark .events .eventsContainer .cInfo .center button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .events .eventsContainer .cInfo .right button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .events .eventsContainer .cInfo .eventsButtons {
  flex: 1 1;
  display: flex;
  gap: 10px;
  align-items: center;
}
@media (max-width: 960px) {
  .theme-dark .events .eventsContainer .cInfo .eventsButtons {
    flex-wrap: wrap;
  }
}
.theme-dark .events .eventsContainer .cInfo .eventsButtons button {
  border: none;
  background-color: #5271ff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}
.theme-dark .events .eventsContainer .cInfo .eventsButtons a {
  color: #d1d0c9;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/events/events.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AADN;AAGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAIM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAFR;AAKI;EACE,kBAAA;AAHN;ADgBE;ECdE;IAII,aAAA;EAFN;AACF;ADgBE;ECnBE;IAQI,aAAA;EADN;AACF;AAGM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADR;ADRE;ECHI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EAAR;AACF;AAGQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADV;AAGU;EACE,eAAA;EACA,gBAAA;AADZ;AAIU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AAFZ;AAMU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAJZ;AAMY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAJd;AAMc;EACE,eAAA;AAJhB;AAQU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AANZ;AAYU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAVZ;AAcQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAZV;ADnEE;EC2EM;IAOI,eAAA;EAXV;AACF;AAaU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAXZ;AAcU;EACE,WAAA;AAZZ;AD9GI;ECjBA,sBAAA;EACA,kBAAA;AAkIJ;AAjII;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAmIN;AAjIM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAmIR;AAhIM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AAkIR;AA/HI;EACE,kBAAA;AAiIN;ADpHE;ECdE;IAII,aAAA;EAkIN;AACF;ADpHE;ECnBE;IAQI,aAAA;EAmIN;AACF;AAjIM;EACE,aAAA;EAGA,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAmIR;AD5IE;ECHI;IAeI,sBAAA;IACA,YAAA;IACA,aAAA;IACA,iBAAA;EAoIR;AACF;AAjIQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAmIV;AAjIU;EACE,eAAA;EACA,gBAAA;AAmIZ;AAhIU;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAkIZ;AA9HU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAgIZ;AA9HY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAgId;AA9Hc;EACE,eAAA;AAgIhB;AA5HU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA8HZ;AAxHU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA0HZ;AAtHQ;EACE,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAwHV;ADvME;EC2EM;IAOI,eAAA;EAyHV;AACF;AAvHU;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAyHZ;AAtHU;EACE,cAAA;AAwHZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.events {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n    .images {\n      width: 100%;\n      height: 300px;\n      position: relative;\n\n      .cover {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .eventsPic {\n        width: 200px;\n        height: 200px;\n        border-radius: 50%;\n        object-fit: cover;\n        position: absolute;\n        left: 0;\n        right: 0;\n        margin: auto;\n        top: 200px;\n      }\n    }\n    .eventsContainer {\n      padding: 20px 70px;\n\n      @include mobile{\n        padding: 10px;\n      }\n\n      @include tablet{\n        padding: 20px;\n      }\n\n      .cInfo {\n        height: 180px;\n        -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n        border-radius: 20px;\n        background-color: themed(\"bg\");\n        color: themed(\"textColor\");\n        padding: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n        @include mobile{\n          flex-direction: column;\n          height: 30vh;\n          padding: 20px;\n          margin-top: 100px;\n        }\n\n        \n        .center {\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 10px;\n\n          span {\n            font-size: 30px;\n            font-weight: 500;\n          }\n\n          .eventsName {\n            font-size: xx-large;\n            font-weight: 500;\n            border-radius: 20%;\n            padding: 5px;\n            background-color: themed(\"bgSoft\");\n            z-index: 99;\n          }\n          \n\n          .info {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n\n            .item {\n              display: flex;\n              align-items: center;\n              gap: 5px;\n              color: themed(\"textColorSoft\");\n\n              span {\n                font-size: 12px;\n              }\n            }\n          }\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n\n\n        .right {\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n        \n        .eventsButtons {\n          flex: 1;\n          display: flex;\n          gap: 10px;\n          align-items: center;\n\n          @include tablet{\n            flex-wrap: wrap;\n          }\n\n          button {\n            border: none;\n            background-color: #5271ff;\n            color: white;\n            padding: 10px 20px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n\n          a{\n            color: themed(\"textColorSoft\");\n          }\n        }\n\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
